import React, { FC } from 'react';
import Image from 'next/image';
import { fromMarkdown, renderParagraphs } from '@lib/utils';
import { SimProductSectionT } from '@factories/RowFactory/components/SimProductSection/types';
import {
  StyledSimProductSection,
  ProductContainer,
  ProductHeader,
  ProductBody,
  ProductImageContainer,
  ProductContent,
  ProductDescription,
  ContactBoxesContainer,
  ContactBox,
  BottomText,
} from '@factories/RowFactory/components/SimProductSection/styled/StyledSimProductSection';
import Link from 'next/link';

export const SimProductSection: FC<SimProductSectionT> = ({
  display,
  title,
  subtitle,
  titleProduct,
  imageProduct,
  descriptionProduct,
  SimProductContact,
  bottomText,
}) => {
  if (!display) return null;

  return (
    <StyledSimProductSection id="sim-product-section">
      {title && <h2>{title}</h2>}
      {subtitle && <h3>{subtitle}</h3>}

      <ProductContainer>
        <ProductHeader>
          <h4>{titleProduct}</h4>
        </ProductHeader>

        <ProductBody>
          {imageProduct && (
            <ProductImageContainer>
              <Image
                src={imageProduct.url as string}
                alt={imageProduct.alternativeText || ''}
                width={imageProduct.width || 300}
                height={imageProduct.height || 300}
                objectFit="contain"
              />
            </ProductImageContainer>
          )}

          <ProductContent>
            <ProductDescription>
              {fromMarkdown({ text: descriptionProduct, isHeading: false })}
            </ProductDescription>

            {SimProductContact && SimProductContact.length > 0 && (
              <ContactBoxesContainer>
                {SimProductContact.map(
                  (contact, index) =>
                    contact.display && (
                      <ContactBox key={`contact-${index}`}>
                        <a href={contact.url}>
                          {contact.title && <h5>{contact.title}</h5>}
                          {renderParagraphs({ body: contact.description, hasMarkdown: true })}
                        </a>
                      </ContactBox>
                    ),
                )}
              </ContactBoxesContainer>
            )}
          </ProductContent>
        </ProductBody>
      </ProductContainer>

      {bottomText && (
        <BottomText>{renderParagraphs({ body: bottomText, hasMarkdown: true })}</BottomText>
      )}
    </StyledSimProductSection>
  );
};

export default SimProductSection;
